import { useCallback } from 'react'
import { getTokenBalances } from '../utils/getTokenBalances'
import { useTokenBalances, useUserTokens } from '../state'
import useConfig from './useConfig'
import { ensureChainFusionAddresses, walletFromPrincipal } from '../providers/WalletProvider'

export default () => {
  const { tokens } = useConfig()
  const { toggleToken, isTokenAdded } = useUserTokens()
  const { setBalances } = useTokenBalances()

  const findTokens = useCallback(
    async (principalId: string) => {
      await ensureChainFusionAddresses(principalId)

      const wallet = walletFromPrincipal(principalId)
      const balances = await getTokenBalances(wallet, tokens)

      setBalances(principalId, balances)

      tokens.forEach((token) => {
        const balance = balances.find((balance) => balance.id === token.id)
        const tokenAdded = isTokenAdded(wallet.principalId, token)

        if (!tokenAdded && balance && balance.balance > 0) {
          toggleToken(wallet.principalId, token.id)
        } else if (tokenAdded && (!balance || balance?.balance === 0)) {
          toggleToken(wallet.principalId, token.id)
        }
      })
    },
    [JSON.stringify(tokens), toggleToken, isTokenAdded]
  )

  return { findTokens }
}
